import { CookieState } from "./CookieState";
import "svelte-i18n";
export default class CookieBarOption {
    constructor(cookieStore, code, languages = {}, onlyRead = false, defaultEnable = true, onLoad = null, onUpdate = null) {
        this._localeTag = 'cs';
        this._languages = {
            cs: {
                title: 'Title',
                subTitle: '',
                description: 'Description',
            }
        };
        this._cookieStore = cookieStore;
        this._code = code;
        this._languages = languages;
        this._onlyRead = onlyRead;
        this._defaultEnable = defaultEnable;
        this._onLoad = onLoad;
        this._onUpdate = onUpdate;
    }
    get code() {
        return this._code;
    }
    get title() {
        return this.getLanguage(this._localeTag)['title'];
    }
    get subTitle() {
        return this.getLanguage(this._localeTag)['subTitle'];
    }
    get description() {
        return this.getLanguage(this._localeTag)['description'];
    }
    get onlyRead() {
        return this._onlyRead;
    }
    get enable() {
        return (this.state === CookieState.Undefined && this._defaultEnable) || this.state === CookieState.Confirmed;
    }
    get state() {
        return this._cookieStore.getOptionState(this._code);
    }
    set setOnLoad(onLoad) {
        this._onLoad = onLoad;
    }
    set setOnUpdate(onUpdate) {
        this._onUpdate = onUpdate;
    }
    onLoad() {
        if (typeof this._onLoad === 'function') {
            this._onLoad(this);
        }
    }
    onUpdate() {
        if (typeof this._onUpdate === 'function') {
            this._onUpdate(this);
        }
    }
    setLocaleTag(localeTag) {
        this._localeTag = localeTag;
    }
    addLanguage(localeTag, language) {
        this._languages[localeTag] = language;
        return this;
    }
    getLanguage(localetag) {
        return this._languages[localetag] === undefined ? this._languages['cs'] : this._languages[localetag];
    }
}
